import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-billing-success-page',
  templateUrl: './update-billing-success-page.component.html',
  styleUrls: ['./update-billing-success-page.component.scss']
})
export class UpdateBillingSuccessPageComponent implements OnInit {

  constructor() { }

  message: string = '';
  
  ngOnInit() {
  }

}
